export default __webpack_public_path__ + "static/media/HTML_-_adamr.space___Codecademy.2ab4bc97.pdf";